import { useQuery } from '@tanstack/react-query'
import { fetchOrgLijsten } from '@/api/lijsten'

export function useOrgLijsten(orgId: number | null | undefined) {
  return useQuery({
    queryKey: ['lijsten', orgId],
    queryFn: () => fetchOrgLijsten(orgId!),
    enabled: !!orgId,
    staleTime: 60_000,
  })
}
